import React, { Component, Fragment } from 'react';
import ReactTable from 'react-table'
import { getSchoolGrades, groupBy, showFile, _addNotificationError } from '../../../../server/util'
import { get } from '../../../../server/actions'
import TmExportExcel from '../../../Misc/tmExportExcel/tmExportExcel';
class TempEligibilityReport extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: [],
            eligTypes: []
        }
    }
    componentDidMount = () => {
        this.getData();
    }
    btnExportExcelOnClick = (e) => {
        const btn = document.getElementById('btnExportExcel');
        if (btn) {
            btn.click();
        }
    }
    downloadPdf = (e) => {
        this.props.showHideLoading(true);
        const eligTypeParam = this.state.eligTypes.length > 0
            ? '&' + this.state.eligTypes.map(t => `eligType=${encodeURIComponent(t)}`).join('&')
            : '';
        const url = `/reports/fmActualReport?mealSchoolId=${sessionStorage.getItem('SchoolId')}${eligTypeParam}&fileType=pdf&isTemp=true&schoolYear=${sessionStorage.getItem('schoolYearValue')}&access_token=`;
        get(url).then((response) => {
            if (!response.ok) {
                if (response.status === 417) {
                    return response.json();
                }
            }
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                throw Error(res.statusMessage);
            } else if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                return res.blob();
            }
        }).then(blob => {
            let filename = "Temp Eligibility Report";
            showFile(blob, filename);
            this.props.showHideLoading(false);
        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, this.props)
                this.props.showHideLoading(false)
            }
        )
    }
    handleEligTypeChange = (type) => {
        const current = this.state.eligTypes;
        let updated;
        if (current.includes(type)) {
            updated = current.filter(t => t !== type);
        } else if (type === 'Regular') {
            updated = ['Regular'];
        } else {
            updated = [...current.filter(t => t !== 'Regular'), type];
        }
        this.setState({ eligTypes: updated }, () => {
            this.getData();
        });
    };
    getData = () => {
        this.props.showHideLoading(true);
        get(`/reports/fmActualReport?mealSchoolId=${sessionStorage.getItem('SchoolId')}&fileType=AllData&isTemp=true&schoolYear=${sessionStorage.getItem('schoolYearValue')}&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            const { eligTypes } = this.state;
            const resData = (data.response || []).filter(item => {
                if (eligTypes.length === 0) return true;
                const isFree = item.freeMeal === true && item.reducedPrice === false;
                const isReduced = item.reducedPrice === true && item.freeMeal === false;
                const isRegular = item.freeMeal === false && item.reducedPrice === false;
                return (eligTypes.includes('Free') && isFree) ||
                    (eligTypes.includes('Reduced') && isReduced) ||
                    (eligTypes.includes('Regular') && isRegular);
            })
            this.setState({ data: resData })
            this.props.showHideLoading(false);
        }).catch(error => {
            this.props.showHideLoading(false);
            console.log("Loading Report Failed", error)
        })
    };

    getColumns = () => {
        const gradeGroup = groupBy(getSchoolGrades(0, false), 'value');
        let columns = [
            { Header: "StudentId", accessor: "studentId" },
            { Header: "Student First Name", Cell: props => <span>{props.original.studentFName}</span> },
            { Header: "Student Last Name", Cell: props => <span>{props.original.studentLName}</span> },
            {
                Header: "Grade", style: { textAlign: 'center', textTransform: 'capitalize' }, Cell: (props) => {
                    return <span>{
                        ((gradeGroup[props.original.gradeName] || [])[0] || {}).label || ''}</span>
                }
            },
            { Header: "Teacher", accessor: "teacherName" },
            { Header: "Eligibility", Cell: props => <span>{(props.original.freeMeal) === true ? 'FreeMeals' : (props.original.reducedPrice) === true ? 'ReducedPrice' : 'RegularPrice'}</span> }
        ];
        return columns
    }
    buildDataFormatForExport = () => {
        const gradeGroup = groupBy(getSchoolGrades(0, false), 'value');
        return (
            [{
                columns: [{ title: 'Student Id' }, { title: 'Student' }, { title: 'Grade' },
                { title: 'Teacher' }, { title: 'Eligibility' }],
                data: this.state.data.map(item => {
                    const itm = {
                        studentId: item.studentId,
                        student: item.studentLName + ' ' + item.studentFName,
                        grade: ((gradeGroup[item.gradeName] || [])[0] || {}).label || '',
                        teacher: item.teacherName,
                        eligibility: (item.freeMeal) === true ? 'FreeMeals' : (item.reducedPrice) === true ? 'ReducedPrice' : 'RegularPrice'

                    }
                    return [{ value: itm.studentId || '' }, { value: itm.student || '' }
                        , { value: itm.grade || '' }, { value: itm.teacher || '' }, { value: itm.eligibility || '' }]
                })
            }]
        )
    }
    render() {
        const gradeGroup = groupBy(getSchoolGrades(0, false), 'value');
        return (<Fragment>
            <div className="row">

                <div className="col-sm-5 col-xs-5 col-sm-offset-6">
                    <div style={{ display: 'inline-flex', alignItems: 'center' }}><label style={{ margin: '3px 7px', fontWeight: 'bold' }}> Type: </label>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            {['Free', 'Reduced', 'Regular'].map(type => {
                                const { eligTypes } = this.state;
                                const hasRegular = eligTypes.includes('Regular');
                                const hasFreeOrReduced = eligTypes.includes('Free') || eligTypes.includes('Reduced');
                                const isDisabled = (type === 'Regular' && hasFreeOrReduced) || (type !== 'Regular' && hasRegular);
                                return (
                                    <div key={type} className="styled-input-single" style={{ padding: '0 0 0 30px', marginRight: '16px', opacity: isDisabled ? 0.4 : 1 }}>
                                        <input
                                            type="checkbox"
                                            id={'tempEligType' + type}
                                            value={type}
                                            checked={eligTypes.includes(type)}
                                            onChange={() => this.handleEligTypeChange(type)}
                                            disabled={isDisabled}
                                        />
                                        <label htmlFor={'tempEligType' + type} style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}>{type}</label>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                </div>
                <div className="col-sm-1">
                    <TmExportExcel name={"Students List"} filename={"Students List"}
                        element={<button id="btnExportExcel" className="btn btn-warning btn-sm pull-right" style={{ marginTop: '-11px', display: 'none' }}><i className="fa fa-file-excel-o"></i> Export</button>}
                        dataSet={this.buildDataFormatForExport()}
                    />
                </div>

            </div>
            <div className="row">
                <div className="col-md-12">
                    <ReactTable className="-striped -highlight"
                        data={this.state.data}
                        columns={this.getColumns()}
                        defaultPageSize={10}
                    />
                </div>
            </div>
        </Fragment>);
    }
}

export default TempEligibilityReport;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/CliamReport/tempEligibilityReport.jsx